//import Vue from 'vue'
import router from '@/router'
//import firebase from 'firebase'
import coreService from '@/services/core'
import moment from "moment-timezone";
export default {
    namespaced: true,
    state: {
      idToken: null,
      userId: null,
      userData: null,
      error: null,
      loading: false
    },
    mutations: {
      authUser (state, userData) {
        state.idToken = userData.idToken
        state.userId = userData.userId
        state.userData = userData.userData
      },
      storeUser (state, user) {
        state.user = user
      },
      clearAuthData (state) {
        state.idToken = null
        state.userId = null
        state.userData = null
      },
      errorMessage (state, error) {
        state.error = error
      },
      loadingStatus(state, loading) {
        state.loading = loading
      }
    },
    actions: {
      setUserLogin ({commit,dispatch}){
        if(localStorage.getItem('userId')){
          const date = moment(new Date(localStorage.getItem('expirationDate'))).add(-1, 'days')
          if(moment().isAfter(date)){
            dispatch('logout')
          }else{
            commit('authUser', {
              idToken: localStorage.getItem('idToken'),
              userId: localStorage.getItem('userId'),
              userData: JSON.parse(localStorage.getItem('userData')),
            })
          }
        }
      },
      setLogoutTimer ({commit}, expirationTime) {
        setTimeout(() => {
          commit('clearAuthData')
        }, expirationTime * 1000)
      },
      login ({commit, dispatch}, authData) {
        commit('loadingStatus', true)
        /*
        firebase.auth().signInWithEmailAndPassword(authData.email, authData.password).then(res => {
            const now = new Date()
            const expirationDate = new Date(now.getTime() + Vue.config['sessionExpire'] * 1000)
            localStorage.setItem('idToken', res.refreshToken)
            localStorage.setItem('userId', res.uid)
            localStorage.setItem('userEmail', authData.email)
            localStorage.setItem('expirationDate', expirationDate)
            commit('authUser', {
                idToken: res.refreshToken,
                userId: res.uid,
                userEmail: authData.email
            })
            dispatch('setLogoutTimer', Vue.config['sessionExpire'])
            dispatch('clearError')
            commit('loadingStatus', false)
            router.replace('/')
        }).catch(function(error) {
            var errorCode = error.code
            var errorMessage = error.message
            if (errorCode === 'auth/wrong-password') {
                console.log('Wrong password.')
            } else {
                console.log(errorMessage)
            }
            dispatch('clearError')
            setTimeout(() => {
              commit('errorMessage', errorMessage)
              commit('loadingStatus', false)
            }, 500);

        })*/
        coreService.login(authData.email, authData.password)
          .then((response) => {

            


            const now = new Date()
            const expirationDate = new Date(now.getTime() + response.ttl * 1000)
            localStorage.setItem('idToken', response.id)
            localStorage.setItem('userId', response.userId)
            localStorage.setItem('userData', JSON.stringify(response.identity))
            localStorage.setItem('expirationDate', expirationDate)
            commit('authUser', {
                idToken: response.id,
                userId: response.userId,
                userData: response.identity
            })
            dispatch('clearError')
            commit('loadingStatus', false)
            router.replace('/')
          })
          .catch((error) => {
            //var errorCode = error.statusCode
            const errorMessage = error.message
            dispatch('clearError')
            setTimeout(() => {
              commit('errorMessage', errorMessage)
              commit('loadingStatus', false)
            }, 500);
          })
      },
      logout ({commit}) {
        commit('clearAuthData')
        //firebase.auth().signOut()
        localStorage.removeItem('expirationDate')
        localStorage.removeItem('idToken')
        localStorage.removeItem('userId')
        localStorage.removeItem('userData')
        router.replace('/login')
      },
      clearError ({commit}) {
        commit('errorMessage', null)
      }
    },
    getters: {
        user : state => {
            return state.userData
        },
        idToken : state => {
            return state.idToken
        },
        error : state => {
            return state.error
        },
        loading: state => {
          return state.loading
        },
        checkLogin : state => {
          return (state.userId)?true:false
        }
    }
  }